import React from 'react';


type Props = {
  children: React.ReactNode;
}

export const MainContent = (props: Props): React.ReactElement => {
  return (
    <div className="main-content">
      {props.children}
    </div>
  )
}
